/** Form durum seçenekleri (drawer) */
export const FORM_STATUS_OPTIONS = [
  { value: "active", label: "Aktif" },
  { value: "inactive", label: "Pasif" },
];

/** Klinik tipi: Kurumsal / Bireysel (Select value string; form'da boolean'a çevrilir) */
export const CORPORATE_TYPE_OPTIONS = [
  { value: "false", label: "Bireysel" },
  { value: "true", label: "Kurumsal" },
];

/** Klinik profili seçenekleri (oluştururken; sonradan Modüller sekmesinden) */
export { PROFILE_OPTIONS } from "../../constants/clinicModules";

/** Cinsiyet seçenekleri */
export const GENDER_OPTIONS = [
  { value: "Erkek", label: "Erkek" },
  { value: "Kadın", label: "Kadın" },
];

/** Haftanın günleri */
export const WEEKDAYS = [
  { value: "Pazartesi", label: "Pzt" },
  { value: "Salı", label: "Sal" },
  { value: "Çarşamba", label: "Çar" },
  { value: "Perşembe", label: "Per" },
  { value: "Cuma", label: "Cum" },
  { value: "Cumartesi", label: "Cmt" },
  { value: "Pazar", label: "Paz" },
];

/** Saat seçenekleri (24 saat formatı, 30 dk aralık) */
export const TIME_OPTIONS = (() => {
  const opts = [];
  for (let h = 0; h < 24; h++) {
    for (let m = 0; m < 60; m += 30) {
      const val = `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
      opts.push(val);
    }
  }
  return opts;
})();

/** Varsayılan form değerleri */
export const DEFAULT_FORM_VALUES = {
  name: "",
  email: "",
  clinicManagerName: "",
  clinicManagerSurname: "",
  clinicManagerGender: "",
  clinicManagerTcNo: "",
  clinicManagerTellNo: "",
  clinicManagerPassword: "",
  clinicManagerPasswordConfirm: "",
  phone: "",
  website: "",
  logoUrl: "",
  logoIconUrl: "",
  logoFile: null,
  logoIconFile: null,
  clearLogo: false,
  clearLogoIcon: false,
  workingSchedule: [],
  description: "",
  status: "active",
  isCorporate: false,
  taxNumber: "",
  taxOffice: "",
  city: "",
  district: "",
  fullAddress: "",
  themeColor: null,
  profiles: ["dietitian", "modern", "traditional"],
};
